
import BannerContainer from '~/components/child/banner/BannerContainer.vue';
import TagContainer from '~/components/child/tag/TagContainer.vue';
import RecipeContainer from '~/components/child/recipe/RecipeContainer.vue';
import BrowseContainer from '~/components/child/browse/BrowseContainer.vue';
import ArticleChannelContainer from '~/components/child/article/ArticleChannelContainer.vue';
import BloggerRankingChannel from '~/components/child/blogger/BloggerRankingChannel.vue';
import ArticleHotContainer from '~/components/child/article/ArticleHotContainer.vue';
export default {
    name: "travel",
    components: { BannerContainer, TagContainer, RecipeContainer, BrowseContainer, ArticleChannelContainer, BloggerRankingChannel, ArticleHotContainer },
    head() {
        return {
            title: '住家-PIXNET痞客邦',
            meta: [
                { hid: 'description', name: 'description', content: '痞客邦住家頻道探討與住家相關的議題，涵蓋裝潢搬家、購屋、賣屋以及各種房產相關知識、居家佈置整理等主題。在這裡，您可以分享您的經驗和尋求專業建議，與其他成員一起交流和討論。無論您是尋找裝潢靈感、購屋買賣的建議，還是想要改善居家環境，我們的平台將提供您所需的資訊和資源。立即加入我們，一起發表文章、分享資料，共同探索住家的美好世界！' },
                { hid: 'og:description', name: 'og:description', property: 'og:description', content: '痞客邦住家頻道探討與住家相關的議題，涵蓋裝潢搬家、購屋、賣屋以及各種房產相關知識、居家佈置整理等主題。在這裡，您可以分享您的經驗和尋求專業建議，與其他成員一起交流和討論。無論您是尋找裝潢靈感、購屋買賣的建議，還是想要改善居家環境，我們的平台將提供您所需的資訊和資源。立即加入我們，一起發表文章、分享資料，共同探索住家的美好世界！' },
                { hid: 'twitter:description', name: 'twitter:description', property: 'twitter:description', content: '痞客邦住家頻道探討與住家相關的議題，涵蓋裝潢搬家、購屋、賣屋以及各種房產相關知識、居家佈置整理等主題。在這裡，您可以分享您的經驗和尋求專業建議，與其他成員一起交流和討論。無論您是尋找裝潢靈感、購屋買賣的建議，還是想要改善居家環境，我們的平台將提供您所需的資訊和資源。立即加入我們，一起發表文章、分享資料，共同探索住家的美好世界！' },
                { hid: 'keywords', name: 'keywords', content: '房屋裝潢、購屋指南、房產投資、住宅貸款、租屋市場、室內設計、家居改造、房產交易、住宅安全、綠建築' },
                { hid: 'og:title', name: 'og:title', property: 'og:title', content: "住家-PIXNET痞客邦"},
                { property: 'og:image', property: 'og:image', content: "https://www.pixnet.net/img/public/og/img_home_og.png"},
                { property: 'og:image:secure_url', property: 'og:image:secure_url', content: "https://www.pixnet.net/img/public/og/img_home_og.png"},
                { property: 'twitter:image', property: 'twitter:image', content: "https://www.pixnet.net/img/public/og/img_home_og.png"},
                { property: 'image', name: 'image', itemprop: 'image', content: "https://www.pixnet.net/img/public/og/img_home_og.png"},
            ],
            link: [
                { rel: 'canonical', href: 'https://www.pixnet.net/channel/home', key: "canonical"}
            ]
        }
    },
    jsonld() {
        return {
            "@context": " https://schema.org/",
            "@graph": [
                {
                    "@context":"https://schema.org",
                    "@type":"Organization",
                    "url":"https://www.pixnet.net",
                    "logo":"https://www.pixnet.net/img/public/og/img_home_og.png",
                    "name":"痞客邦",
                    "@id":"https://www.pixnet.net/#organization",
                    "description":"痞客邦住家頻道探討與住家相關的議題，涵蓋裝潢搬家、購屋、賣屋以及各種房產相關知識、居家佈置整理等主題。在這裡，您可以分享您的經驗和尋求專業建議，與其他成員一起交流和討論。無論您是尋找裝潢靈感、購屋買賣的建議，還是想要改善居家環境，我們的平台將提供您所需的資訊和資源。立即加入我們，一起發表文章、分享資料，共同探索住家的美好世界！",
                    "address":"",
                    "brand":{
                        "@type":"Brand",
                        "logo":"https://www.pixnet.net/img/public/og/img_home_og.png"
                    },
                    "sameAs":"https://www.facebook.com/pixnet.net"
                },
                {
                    "@context":"https://schema.org/",
                    "@type":"BreadcrumbList",
                    "itemListElement":[
                        {
                            "@type": "ListItem",
                            "position": 1,
                            "name": "住家-PIXNET痞客邦",
                            "item": "https://www.pixnet.net",
                            "description": "痞客邦住家頻道探討與住家相關的議題，涵蓋裝潢搬家、購屋、賣屋以及各種房產相關知識、居家佈置整理等主題。在這裡，您可以分享您的經驗和尋求專業建議，與其他成員一起交流和討論。無論您是尋找裝潢靈感、購屋買賣的建議，還是想要改善居家環境，我們的平台將提供您所需的資訊和資源。立即加入我們，一起發表文章、分享資料，共同探索住家的美好世界！",
                            "keywords": "房屋裝潢、購屋指南、房產投資、住宅貸款、租屋市場、室內設計、家居改造、房產交易、住宅安全、綠建築"
                        }
                    ]
                }
            ]
        }
    },
    data() {
        return {
            channel_page_id: 10,
            showAnimation: false,
        }
    },
    computed: {
        is_login() {
            return this.$store.state.login.login_status;
        },
        pa_page_name() {
            return '住家';
        },
        tag_search_text() {
            return '住家';
        },
        day_hot_article() {
            return this.$store.state.article.day_hot_article;
        },
        day_hot_article_full() {
            return this.$store.state.article.day_hot_article_full;
        }
    },
    methods: {
        paFunction() {
            window._piq.push(['trackEvent', 'rs2022::十大頻道::' + this.pa_page_name, 'imps::頁面::page::user_action', '', '']);
        },
        paScrollFunction(){
            addEventListener("scroll", () => {
                window._piq.push(['trackEvent', 'rs2022::十大頻道::' + this.pa_page_name, 'scroll::頁面::page::user_action', '', '']);
            }, { once: true });
        },
        gtag(){
            window.dataLayer.push(arguments);
        },
        activeGaPage() {
            this.gtag('config', 'G-RPGK0ML6QM', {
                'channel_category': '住家'
            });
            this.gtag('config', 'G-45SMZ66RLZ', {
                'channel_category': '住家'
            });
            this.gtag('event', 'page_view', {
                page_title: '住家-PIXNET痞客邦',
            });
        },
        activeMcPage() {
            (function(c,l,a,r,i,t,y){
                c[a]=c[a]||function(){(c[a].q=c[a].q||[]).push(arguments)};
                t=l.createElement(r);t.async=1;t.src="https://www.clarity.ms/tag/"+i;
                y=l.getElementsByTagName(r)[0];y.parentNode.insertBefore(t,y);
            })(window, document, "clarity", "script", "kbvat69or6");
        },
    },
    async fetch(){
        const item = { sort: 'hot', type: 'group', pre_page: 10, id: 10, ver: 2 }
        await this.$store.dispatch("article/getDayHotArticle", item);
    },
    mounted() {
        window.dataLayer = window.dataLayer || [];
        this.activeGaPage();
        this.activeMcPage();
        this.paFunction();
        this.paScrollFunction();
    }
}
